import feature from "./featureSlice";
export default feature;
